<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false">
        <el-form ref="formValidate" :model="model" label-width="120px">
            <el-form-item label="工程ID：" prop="pid1">
                <span>{{model.pid1}}</span>
            </el-form-item>
            <el-form-item label="单位ID：" prop="pid2">
                <span>{{model.pid2}}</span>
            </el-form-item>
            <el-form-item label="分部ID：" prop="pid3">
                <span>{{model.pid3}}</span>
            </el-form-item>
            <el-form-item label="单元ID：" prop="pid4">
                <span>{{model.pid4}}</span>
            </el-form-item>
            <el-form-item label="等级：" prop="grade">
                <span>{{model.grade}}</span>
            </el-form-item>
            <el-form-item label="标题：" prop="title">
                <span>{{model.title}}</span>
            </el-form-item>
            <el-form-item label="文件名称：" prop="file_name">
                <span>{{model.file_name}}</span>
            </el-form-item>
            <el-form-item label="文件大小：" prop="file_size">
                <span>{{model.file_size}}</span>
            </el-form-item>
            <el-form-item label="文件路径：" prop="file_path">
                <span>{{model.file_path}}</span>
            </el-form-item>
            <el-form-item label="后缀名：" prop="suffix">
                <span>{{model.suffix}}</span>
            </el-form-item>
            <el-form-item label="图标：" prop="icon">
                <span>{{model.icon}}</span>
            </el-form-item>
            <el-form-item label="添加时间：" prop="add_time">
                <span>{{model.add_time}}</span>
            </el-form-item>
            <el-form-item label="上传人：" prop="user_id">
                <span>{{model.user_id}}</span>
            </el-form-item>
            <el-form-item label="上传人姓名：" prop="user_name">
                <span>{{model.user_name}}</span>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="closeDialog" size="medium">关 闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'

export default {
    name: 'designDrawingsInfo',
    mixins: [editutil],
    data() {
        return {
            model: {
                pid1: '',
                pid2: '',
                pid3: '',
                pid4: '',
                grade: '',
                title: '',
                file_name: '',
                file_size: '',
                file_path: '',
                suffix: '',
                icon: '',
                add_time: '',
                user_id: '',
                user_name: '',
            },
            getObj:{
                url:'/api/admin/designdrawings/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: [],
        };
    },
    methods: {}
};
</script>